import frontIndex from '@/pages/front'
import frontHome from '@/pages/front/home'
import Mobilehome from '@/pages/front/mobileHome'
import frontlogin from '@/pages/front/login'
import frontpwd from '@/pages/front/front-password'
import devRegiser from '@/pages/front/dev-register'
import developer from '@/pages/front/developer'
import developerdetail from '@/pages/front/developer/detail'
import devDocument from '@/pages/front/dev-document'
import document from '@/pages/front/document'
import documentV2 from '@/pages/front/documentV2'
import summarydetail from '@/pages/front/developer/summary'
import businessCooperation from '@/pages/front/business-cooperation'
import guiding from '@/pages/front/guide'
import autograph from '@/pages/front/autograph'
import exampleCode from '@/pages/front/example-code'

// 资源介绍页面
import introduce from '@/pages/front/introduce'
import resourceIntroduction from '@/pages/front/introduce/resource-introduction'
import questionBankIntroduce from '@/pages/front/introduce/question-bank'
import resourceCenterIntroduce from '@/pages/front/introduce/resource-center'
import historyPaperIntroduce from '@/pages/front/introduce/history-paper'
import paperExample1 from '@/pages/front/introduce/history-paper/paper-example-1'
import paperExample2 from '@/pages/front/introduce/history-paper/paper-example-2'
import paperExample3 from '@/pages/front/introduce/history-paper/paper-example-3'

// 移动端页面
import mobileCooperation from '@/pages/front/mobile-page/business'
import mobileRegister from '@/pages/front/mobile-page/mobileregister'
import mobileLogin from '@/pages/front/mobile-page/mobilelogin'
import mobileForgetpsw from '@/pages/front/mobile-page/forgetpsw'
import mobileEgcode from '@/pages/front/mobile-page/mobileegcode'
import mobiledeveloper from '@/pages/front/mobile-page/mobiledeveloper'
import mobiledetail from '@/pages/front/mobile-page/mobiledeveloper/detail'
import mobilesummary from '@/pages/front/mobile-page/mobiledeveloper/summary'

export default [
  {
    path: '/',
    name: 'frontIndex',
    component: frontIndex,
    redirect: '/front/home',
    meta: {
      index: '/'
    },
    children: [
      {
        path: '/front/home',
        name: 'fronthome',
        component: frontHome,
        meta: {
          index: '/'
        }
      },
      {
        path: '/front/Mobilehome',
        name: 'Mobilehome',
        component: Mobilehome,
        meta: {
          index: '/'
        }
      },
      {
        path: '/front/login',
        name: 'frontlogin',
        component: frontlogin,
        meta: {
          index: '/front/developer'
        }
      },
      {
        path: '/front/pwd',
        name: 'frontpwd',
        component: frontpwd,
        meta: {
          index: '/front/developer'
        }
      },
      {
        path: '/front/devregiser',
        name: 'devregiser',
        component: devRegiser,
        meta: {
          index: '/front/developer'
        }
      },

      {
        path: '/front/developer',
        name: 'developer',
        component: developer,
        meta: {
          index: '/front/developer'
        }
      },
      {
        path: '/front/developer/detail',
        name: 'developerdetail',
        component: developerdetail,
        meta: {
          index: '/front/developer'
        }
      },
      {
        path: '/front/developer/summary',
        name: 'summarydetail',
        component: summarydetail,
        meta: {
          index: '/front/developer'
        }
      },
      {
        path: '/front/business/cooperation',
        name: 'businessCooperation',
        component: businessCooperation,
        meta: {
          index: '/front/business/cooperation'
        }
      }, {
        path: '/front/Mobilehome/business/mobilecooperation',
        name: 'mobileCooperation',
        component: mobileCooperation,
        meta: {
          index: '/front/Mobilehome/business/mobilecooperation'
        }
      }, {
        path: '/front/Mobilehome/mobileRegister',
        name: 'mobileRegister',
        component: mobileRegister,
        meta: {
          index: '/front/Mobilehome/developer/detail'
        }
      }, {
        path: '/front/Mobilehome/mobileLogin',
        name: 'mobileLogin',
        component: mobileLogin,
        meta: {
          index: '/front/Mobilehome/developer'
        }
      }, {
        path: '/front/Mobilehome/mobileForgetpsw',
        name: 'mobileForgetpsw',
        component: mobileForgetpsw,
        meta: {
          index: '/front/Mobilehome/developer/detail'
        }
      }, {
        path: '/front/Mobilehome/mobileEgcode',
        name: 'mobileEgcode',
        component: mobileEgcode,
        meta: {
          index: '/front/Mobilehome/mobileEgcode'
        }
      }, {
        path: '/front/guiding',
        name: 'guiding',
        component: guiding,
        meta: {
          index: '/front/guiding'
        }
      }, {
        path: '/front/introduce',
        name: 'introduce',
        component: introduce,
        children: [
          {
            path: '/front/introduce/resource-introduction',
            name: 'resource-introduction',
            component: resourceIntroduction,
            meta: {
              index: '/front/introduce/resource-introduction'
            }
          },
          {
            path: '/front/introduce/question-bank',
            name: 'questionBankIntroduce',
            component: questionBankIntroduce,
            meta: {
              index: '/front/introduce/question-bank'
            }
          }, {
            path: '/front/introduce/history-paper',
            name: 'historyPaperIntroduce',
            component: historyPaperIntroduce,
            meta: {
              index: '/front/introduce/history-paper'
            }
          }, {
            path: '/front/introduce/resource-center',
            name: 'resourceCenterIntroduce',
            component: resourceCenterIntroduce,
            meta: {
              index: '/front/introduce/resource-center'
            }
          }
        ]
      }, {
        path: '/front/introduce/history-paper/paper-example-1',
        name: 'paperExample1',
        component: paperExample1,
        meta: {
          index: '/front/introduce/history-paper/paper-example-1'
        }
      }, {
        path: '/front/introduce/history-paper/paper-example-2',
        name: 'paperExample2',
        component: paperExample2,
        meta: {
          index: '/front/introduce/history-paper/paper-example-2'
        }
      }, {
        path: '/front/introduce/history-paper/paper-example-3',
        name: 'paperExample3',
        component: paperExample3,
        meta: {
          index: '/front/introduce/history-paper/paper-example-3'
        }
      }, {
        path: '/front/autograph',
        name: 'autograph',
        component: autograph,
        meta: {
          index: '/front/autograph'
        }
      }, {
        path: '/front/example/code',
        name: 'exampleCode',
        component: exampleCode,
        meta: {
          index: '/front/example/code'
        }
      }, {
        path: '/front/devDocument/index',
        name: 'devDocument',
        component: devDocument,
        meta: {
          index: '/front/devDocument/index'
        }
      },
      {
        path: '/front/documentV1/index',
        name: 'document',
        component: document,
        meta: {
          index: '/front/documentV1/index'
        }
      },
      {
        path: '/front/document/index',
        name: 'documentV2',
        component: documentV2,
        meta: {
          index: '/front/document/index'
        }
      },
      {
        path: '/front/Mobilehome/developer',
        name: 'mobiledeveloper',
        component: mobiledeveloper,
        children: [{
          path: '/front/Mobilehome/developer/detail',
          name: 'mobiledetail',
          component: mobiledetail,
          meta: {
            index: '/front/Mobilehome/developer/detail'
          }
        }, {
          path: '/front/Mobilehome/developer/summary',
          name: 'mobilesummary',
          component: mobilesummary,
          meta: {
            index: '/front/Mobilehome/developer/detail'
          }
        }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/front/index.js